export default "__VITE_ASSET__JTfPHDYW__"